import { motion } from "framer-motion";
import { useState } from "react";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/content";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-20 md:py-32" data-testid="faq">
      <div className="max-w-[1440px] mx-auto px-5 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-14">
          <div className="col-span-12 md:col-span-5">
            <div className="eyebrow mb-4">Frequently asked</div>
            <h2 className="font-display text-3xl md:text-5xl leading-[1.05] tracking-[-0.02em]">
              Answers, <br /><span className="text-[hsl(var(--primary))]">before you ask.</span>
            </h2>
            <p className="mt-6 text-[hsl(var(--ink-soft))] max-w-sm leading-relaxed">
              Common questions from patients across Andheri East, Powai, Marol and Sakinaka.
            </p>
          </div>

          <div className="col-span-12 md:col-span-7 flex flex-col gap-3 md:gap-4 mt-6 md:mt-0">
            {FAQS.map((f, i) => (
              <div
                key={f.q}
                className={`card-soft transition-colors duration-500 ${open === i ? "bg-[hsl(var(--primary-light))]/70" : "bg-white"}`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full p-5 md:p-7 flex items-center justify-between gap-4 md:gap-6 text-left"
                  aria-expanded={open === i}
                >
                  <span className="font-display text-base md:text-xl leading-tight">{f.q}</span>
                  <span className={`shrink-0 w-8 h-8 md:w-9 md:h-9 rounded-full flex items-center justify-center transition-all duration-500 ${open === i ? "bg-[hsl(var(--primary))] text-white rotate-45" : "bg-[hsl(var(--primary-light))] text-[hsl(var(--primary-dark))]"}`}>
                    <Plus size={16} strokeWidth={2} />
                  </span>
                </button>
                <motion.div
                  initial={false}
                  animate={{ height: open === i ? "auto" : 0, opacity: open === i ? 1 : 0 }}
                  transition={{ duration: 0.45, ease: [0.2, 0.7, 0.2, 1] }}
                  className="overflow-hidden"
                >
                  <p className="px-5 md:px-7 pb-5 md:pb-7 text-[14px] md:text-base text-[hsl(var(--ink-soft))] leading-relaxed">{f.a}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org", "@type": "FAQPage",
              mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
            }),
          }}
        />
      </div>
    </section>
  );
}
